import { Configure, InstantSearch, InstantSearchServerState, InstantSearchSSRProvider } from "react-instantsearch";

import { Hit } from "~/components/products/search-product-grid-algolia";
import CustomInfiniteHits from "~/components/search/custom-infinite-hits";
import { searchClient } from "~/components/search/search-client";
import Algolia from "~/types/algolia";
import CommonUtils from "~/utils/common-utils";

import AlgoliaProductListing from "./algolia-product-listing";

type Props = {
  serverState?: InstantSearchServerState;
  algoliaIndexId: string;
  categoryId: string;
  components?: any;
  listScope: string;
};

export default function ProductGridSkeleton(props: Props) {
  const { serverState, categoryId, components, listScope, algoliaIndexId } = props;

  const categoryLevel = categoryId.split("_").length;

  const algoliaPLPConfig = CommonUtils.parseJsonSafely(
    process.env.NEXT_PUBLIC_ALGOLIA_PLP_CONFIG!
  ) as Algolia.Configuration;

  return (
    <InstantSearchSSRProvider {...serverState}>
      <InstantSearch
        searchClient={searchClient}
        indexName={algoliaIndexId}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
        insights
      >
        <Configure
          {...algoliaPLPConfig}
          disjunctiveFacetsRefinements={{ [`categories.lvl${categoryLevel}`]: [categoryId] }}
        />
        {serverState ? (
          <AlgoliaProductListing components={components} listScope={listScope} categoryId={props.categoryId} />
        ) : (
          <CustomInfiniteHits hitComponent={Hit} showPrevious={false} />
        )}
      </InstantSearch>
    </InstantSearchSSRProvider>
  );
}
